module.exports = __webpack_public_path__ + "img/nk.42fb7736.png";